import { QUIZ_PRODUCT_TYPES } from '@/modules/product/domain/product';
import ProductService from '@/modules/product/domain/ProductService';
import { PRICING_MODELS } from '@/services/constants';

/**
 * Service for managing upsell initialization and normalization
 */
const UpsellService = {
  /**
   * Initialize upsell data from query parameters
   * @param {Object} query - Route query parameters
   * @param {String} countryCode - User's country code (fallback if region not in query)
   * @param {Function} getBrand - Function to get current brand
   * @returns {Object} Normalized upsell data
   */
  initializeUpsellData(query, countryCode, getBrand) {
    const { 'product-type': productType, 'pricing-model': pricingModel, region } = query;

    const upsellPricingModel = this.normalizePricingModel(pricingModel);
    const upsellProductType = this.normalizeProductType(productType);

    return {
      upsellProductType,
      upsellPricingModel,
      region: region?.toUpperCase() || countryCode,
      brand: getBrand(),
    };
  },

  /**
   * Normalize pricing model from query parameter
   * @param {String} pricingModel - Raw pricing model from query
   * @returns {String} Normalized pricing model
   */
  normalizePricingModel(pricingModel) {
    const normalized = pricingModel ? pricingModel.charAt(0).toUpperCase() + pricingModel.slice(1) : pricingModel;

    return ProductService.isValidPricingModel(normalized) ? normalized : PRICING_MODELS.weekly;
  },

  /**
   * Normalize product type from query parameter
   * @param {String} productType - Raw product type from query
   * @returns {String} Normalized product type
   */
  normalizeProductType(productType) {
    return ProductService.isValidProductType(productType) ? productType : QUIZ_PRODUCT_TYPES.nutritionMenopause;
  },
};

export default UpsellService;
